/* eslint-disable react-hooks/exhaustive-deps */
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { SecondaryButton } from "../../StyledCss/styledbtn";
import { getUserLeavesHistory } from "../../api/services/hroneApi";
import { convertKeysToCamelCase } from "../../util/convertCamelCase";
import formatDate from "../../util/formatdate";
import LeaveCancelForm from "../LeaveCancelForm/leaveCancelForm";
import PopupModal from "../PopupModal";
import LoadingView from "../LoadingView";
import FailureView from "../FailureView";
import { usePermissions } from "../../redux/slices/permissionsSlice";
import { FEATURE_CODES } from "../../util/featureCodes";
import "./index.css";

const apiStatusConstants = {
  initial: "INITIAL",
  success: "SUCCESS",
  failure: "FAILURE",
  inProgress: "IN_PROGRESS",
};

const LeaveHistoryTable = ({ startMonth, endMonth, refetchData }) => {
  const [rowData, setRowData] = useState([]);
  const [apiStatus, setApiStatus] = useState(apiStatusConstants.initial);
  const [isLeaveCancelModalOpen, setIsLeaveCancelModalOpen] = useState(false);
  // const date = new Date();
  const formattedStartMonth = format(startMonth, "yyyy-MM");
  const formattedEndMonth = format(endMonth, "yyyy-MM");
  const [activeCancelId, setActiveCancelId] = useState("");
  const [requestType, setRequestType] = useState("");
  const { hasPermission } = usePermissions();
  const canCancelLeave = hasPermission(FEATURE_CODES.LEAVE_CANCEL);

  useEffect(() => {
    if (formattedStartMonth && formattedEndMonth) {
      getUserLeaves();
    }
  }, [formattedStartMonth, formattedEndMonth]);

  useEffect(() => {
    if (refetchData === true) {
      getUserLeaves();
    }
  }, [refetchData]);

  const getLeavesObj = {
    startMonth: formattedStartMonth,
    endMonth: formattedEndMonth,
  };

  const closeCancelLeaveModal = () => {
    setIsLeaveCancelModalOpen(false);
  };

  const handleButtonClick = async (params) => {
    setIsLeaveCancelModalOpen(true);
    setActiveCancelId(params.leaveId);
    setRequestType(params.requestType);
  };

  const getUserLeaves = async () => {
    setApiStatus(apiStatusConstants.inProgress);
    try {
      const response = await getUserLeavesHistory(getLeavesObj);
      const leaves=await response.json();
      const data = leaves.data

      if (response.ok) {
        const camelCaseData = data.map((leave) =>
          convertKeysToCamelCase(leave)
        );
        const updatedData = camelCaseData.map((eachItem) => {
          const startDate = formatDate(eachItem.startDate);
          const endDate = formatDate(eachItem.endDate);
          return { ...eachItem, startDate, endDate };
        });
        setRowData(updatedData);
        setApiStatus(apiStatusConstants.success);
      }
    } catch (err) {
      setApiStatus(apiStatusConstants.failure);
    }
  };
  const columnDefs = [
    {
      headerName: "START DATE",
      field: "startDate",
      floatingFilter: true,
      filter: true,
      pinned: "left", 
      suppressMenu: true
    },
    {
      headerName: "END DATE",
      field: "endDate",
      floatingFilter: true,
      filter: true,
      pinned: "left", 
      suppressMenu: true
    },
    {
      headerName: "REQUEST DAYS",
      field: "days",
      floatingFilter: true,
      filter: true,
      pinned: "left", 
      suppressMenu: true
    },
    {
      headerName: "REQUEST TYPE",
      field: "requestType",
      floatingFilter: true,
      filter: true,
      pinned: "left", 
      suppressMenu: true
    },
    {
      headerName: "STATUS",
      field: "status",
      floatingFilter: true,
      filter: true,
      suppressMenu: true
    },
    {
      headerName: "REASON FOR LEAVE",
      field: "leaveReason",
      floatingFilter: true,
      filter: true,
      width: 400,
      tooltipField: "leaveReason",
      suppressMenu: true
    },
    {
      headerName: "REJECTION / CANCEL REASON",
      field: "rejectedReason",
      width: 300,
      tooltipField: "rejectedReason",
      suppressMenu: true
      // floatingFilter: true,
      // filter: true,
    },
    {
      headerName: "CANCEL REQUEST",
      width: 200,
      suppressMenu: true,
      cellRenderer: (params) => {
        const status = params.data.status;
        const startDate = params.data.startDate;
        const [day, month, year] = startDate.split('-');
        const appliedStartDate = new Date(year, month - 1, day);
        const currentDate = new Date();
        const currentDateOnly = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        const appliedStartDateOnly = new Date(appliedStartDate.getFullYear(), appliedStartDate.getMonth(), appliedStartDate.getDate());

        
        if (
          canCancelLeave &&
          (status === "Awaiting") &&
          currentDateOnly !== appliedStartDateOnly
        ) {
          return (
            <SecondaryButton
              className="d-flex justify-content-center align-items-center"
              onClick={() => handleButtonClick(params.data)}
            >
              Cancel
            </SecondaryButton>
          );
        }

        return "N/A";
      },
    }

  ];
  const paginationSize = 12;

  const renderTable = () => (
    <div
      className="ag-theme-alpine history-container"
      style={{
        height: "70vh",
        fontSize: "14px",
        fontFamily: "Arial, Helvetica, sans-serif",
      }}
    >
      <AgGridReact
        rowData={rowData}
        columnDefs={columnDefs}
        pagination={true}
        paginationPageSize={paginationSize}
        enableCellTextSelection={true}
      ></AgGridReact>
    </div>
  );

  const renderData = () => {
    switch (apiStatus) {
      case apiStatusConstants.inProgress:
        return <LoadingView />;
      case apiStatusConstants.success:
        return renderTable();
      case apiStatusConstants.failure:
        return <FailureView onClickRetry={getUserLeaves} />;
      default:
        return null;
    }
  };

  return (
    <>
      {renderData()}
        {/* <SlidingModal
          modalName="Leave Cancel"
          closeBtn={closeCancelLeaveModal}
          isModalOpen={isLeaveCancelModalOpen}
        >
          <LeaveCancelForm
            getUserLeaves={getUserLeaves}
            activeCancelId={activeCancelId}
            setIsLeaveCancelModalOpen={setIsLeaveCancelModalOpen}
          />
        </SlidingModal> */}

        <PopupModal
          closeBtn={closeCancelLeaveModal}
          modalName="Cancel Leave Request"
          showModal={isLeaveCancelModalOpen}
          mb ="mb-2"
          paddingTop="18px"
        >
          <LeaveCancelForm
            requestType={requestType}
            closeBtn={closeCancelLeaveModal}
            getUserLeaves={getUserLeaves}
            activeCancelId={activeCancelId}
            setIsLeaveCancelModalOpen={setIsLeaveCancelModalOpen}
          />
        </PopupModal>
   </>
  );
};

export default LeaveHistoryTable;